<template>
  <div class="orders">
    <h1 class="page-title">{{$t('account.order_history')}}</h1>

    <div class="orders">
      <table>
        <thead>
          <tr>
            <td>{{$t('account.invoice')}}</td>
            <td>{{$t('account.total')}}</td>
            <td>{{$t('account.date')}}</td>
            <td>{{$t('account.status')}}</td>
            <td class="actions"></td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(order, key) in orders" :key="key">
            <td>{{order.invoice_no}}</td>
            <td>{{order.grand_total}}</td>
            <td>{{order.created_at}}</td>
            <td>
              <span class="order-status" :class="order.status.slug">{{order.status.name}}</span>
            </td>
            <td class="actions">
              <router-link :to="$i18nRoute({name: 'my-account', params: {page: 'order', action: order.id}})" :class="{'icon-credit-card': order.status.slug=='waiting-to-payment', 'icon-eye': order.status.slug!='waiting-to-payment'}"></router-link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!--<div class="pagination right">-->
      <!--<paginate-->
        <!--v-model="page"-->
        <!--:page-count="total_pages"-->
        <!--:click-handler="paginate"-->
        <!--:prev-text="'Prev'"-->
        <!--:next-text="'Next'"-->
      <!--&gt;</paginate>-->
    <!--</div>-->
  </div>
</template>

<script>
import Api from '@/services/api-service'
export default {
  name: 'orders',
  data () {
    return {
      page: 1,
      total_pages: 5,
      orders: []
    }
  },
  created(){
    this.getOrders()
  },
  methods: {
    paginate (page) {
      // this.getOrders(page)
      // document.getElementById("orders-list").scrollIntoView();
    },
    getOrders () {
      Api.post('get-orders', {
        user_id: this.$store.state.auth.user.id
      })
      .then(response => {
        this.orders = response.data.orders
      })
      .catch(error => {
        console.log(error)
      })
    }
  }
}
</script>

<style lang="scss">
.orders {
  overflow: auto;
  table {
    width: 100%;
    border-collapse: collapse;

    .actions {
      text-align: right;
    }

    thead {
      tr {
        background: rgba(0, 0, 0, 0.1);
      }
    }
    td {
      padding: 10px;
      font-size: 14px;
      white-space: nowrap;
    }
    tbody {
      tr {
        &:nth-child(2n) {
          background: rgba(0, 0, 0, 0.03);
        }
        &:hover {
          background: rgba(0, 0, 0, 0.05);
        }
        .actions {
          font-size: 16px;
          a {
            display: inline-block;
            margin-left: 15px;
            vertical-align: middle;
            &.icon-eye {
              font-size: 13px;
            }
            &.icon-credit-card {
              font-size: 17px;
            }
          }
        }
        .order-status {
          font-size: 12px;
          border-radius: 10px;
          padding: 2px 10px;
          color: #ffffff;
          width: 80px;
          text-align: center;
          &.pending {
            background: #f6993f;
          }
          &.waiting-to-payment {
            background: #e0d300;
          }
          &.processing {
            background: #aa9a56;
          }
          &.completed {
            background: #38c172;
          }
          &.canceled {
            background: #ff0000;
          }
          &.declined {
            background: #ff0000;
          }
        }
      }
    }
  }
}
</style>
